<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

@if (organizationData$ | async; as organizationData) {
  <ptl-v3-auth-layout [organizationData]="organizationData" [showMaintenanceOverlay]="showMaintenanceOverlay">
    <div class="v3-headline">
      <h1 class="v3-title">{{ organizationData.name }}</h1>
      <p class="v3-subtitle fs-body-m">{{ organizationData.landingPage.welcomeMessage }}</p>
    </div>

    @if (!showVerificationCodeForm) {
      <ptl-v3-signup-details-form
        [invitationId]="invitationId"
        [invitationToken]="invitationToken"
        [organizationData]="organizationData"
        (backClicked)="onNavigateToSignIn()"
      ></ptl-v3-signup-details-form>
    }
    <!-- No @else here (v2's template has the same gap): showVerificationCodeForm only flips true from the
      accountCreationSucceeded subscription in SignupFormComponent's ctor, and that state is only ever set by
      UserAuthState.accountCreationSuccess (user-auth.state.ts), which redirects to /unverified-email, /signin,
      or /support/signin in the same handler right after patching it. This component gets torn down by that
      navigation before this state needs its own UI. -->
  </ptl-v3-auth-layout>
} @else {
  <ptl-v3-auth-loading></ptl-v3-auth-loading>
}
